import moment from 'moment';

type AdditionalData = {
    firstName?: string;
    lastName?: string;
    isAzp?: boolean;
  }

export const getModel = (data, additionalData? : AdditionalData) => {
    const {
        firstName, lastName, isAzp,
    } = additionalData || {};

    const presentationData = {
        amount: isAzp ? data?.withdrawal?.investmentAmount ?? data?.productConfiguration?.initialInvestment : data?.withdrawal?.withdrawalAmount,
        frequency: data?.withdrawal?.periodicity?.toString(),
        targetPortfolio: data?.withdrawal?.targetPortfolio?.toString(),
        startDate: data?.withdrawal?.startDate ? moment(data?.withdrawal?.startDate)?.format('MM/YYYY') : null,
        withdrawalsStartDate: data?.withdrawal?.startDate,
        iban: data?.paymentInstruction?.iban ?? '',
        esr: data?.paymentInstruction?.esr ?? '',
        firstName: data?.paymentInstruction?.firstName ?? firstName ?? '',
        lastName: data?.paymentInstruction?.lastName ?? lastName ?? '',
        bankName: data?.paymentInstruction?.bankName ?? '',
        zipCode: data?.paymentInstruction?.zipCity ?? '',
        city: data?.paymentInstruction?.city ?? '',
        duration: data?.withdrawal?.duration,
    };

    return presentationData;
};
